const numberFormat = new Intl.NumberFormat('en-US');

function NumberFormat({ number }) {
  return numberFormat.format(number);
}

export default NumberFormat;
